import React from 'react'
import Icon from './Icon'

const RemoveCircle = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g fill="none">
        <path d="M0 40h40V0H0z"/>
        <path fill="currentColor" d="M20 12c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 15c3.86 0 7-3.14 7-7s-3.14-7-7-7-7 3.14-7 7 3.14 7 7 7zm3.854-10.854a.5.5 0 0 1 0 .707L20.707 20l3.146 3.146a.5.5 0 0 1-.707.707L20 20.707l-3.146 3.146a.5.5 0 1 1-.707-.707L19.293 20l-3.146-3.146a.5.5 0 0 1 .707-.707L20 19.293l3.146-3.146a.5.5 0 0 1 .707 0z"/>
    </g>
  </Icon>
)

export default RemoveCircle



// WEBPACK FOOTER //
// ./icons/RemoveCircle.js